export const formatDateWithTime = (dateString: string): string | null => {
    if (!dateString) return null;

    const cleanedDateString = dateString.replace(/\[.*?\]$/, "");
    const date = new Date(cleanedDateString);

    if (isNaN(date.getTime())) return dateString;

    return date.toLocaleString("nl-NL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    });
};

export default formatDateWithTime;
